import { Navigate, Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { Protected } from './components/Protected';
import {
  About,
  Browse,
  ChordDetail,
  Contributor,
  Directory,
  DirectoryDetail,
  Home,
  NotFound,
  Requests,
} from './pages/Public';
import { AuthPage, VerifyEmail } from './pages/Auth';
import {
  Admin,
  Dashboard,
  Favorites,
  MyRequests,
  Profile,
  Reviewer,
  ReviewDetail,
  SubmissionDetail,
  SubmissionForm,
  Submissions,
} from './pages/Dashboards';
export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/chords/:slug" element={<ChordDetail />} />
        <Route path="/artists" element={<Directory kind="artists" />} />
        <Route path="/artists/:slug" element={<DirectoryDetail kind="artists" />} />
        <Route path="/categories" element={<Directory kind="categories" />} />
        <Route path="/categories/:slug" element={<DirectoryDetail kind="categories" />} />
        <Route path="/genres" element={<Navigate to="/categories" replace />} />
        <Route path="/genres/:slug" element={<DirectoryDetail kind="categories" />} />
        <Route path="/contributors/:slug" element={<Contributor />} />
        <Route
          path="/requests"
          element={
            <Protected>
              <Requests />
            </Protected>
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/forgot-password" element={<AuthPage mode="forgot" />} />
        <Route path="/reset-password" element={<AuthPage mode="reset" />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route
          path="/dashboard"
          element={
            <Protected>
              <Dashboard />
            </Protected>
          }
        />
        <Route
          path="/dashboard/submissions"
          element={
            <Protected>
              <Submissions />
            </Protected>
          }
        />
        <Route
          path="/dashboard/submissions/:id"
          element={
            <Protected>
              <SubmissionDetail />
            </Protected>
          }
        />
        <Route
          path="/dashboard/new"
          element={
            <Protected>
              <SubmissionForm />
            </Protected>
          }
        />
        <Route
          path="/dashboard/submissions/:id/edit"
          element={
            <Protected>
              <SubmissionForm />
            </Protected>
          }
        />
        <Route
          path="/dashboard/favorites"
          element={
            <Protected>
              <Favorites />
            </Protected>
          }
        />
        <Route
          path="/dashboard/requests"
          element={
            <Protected>
              <MyRequests />
            </Protected>
          }
        />
        <Route
          path="/dashboard/profile"
          element={
            <Protected>
              <Profile />
            </Protected>
          }
        />
        <Route
          path="/reviewer"
          element={
            <Protected roles={['REVIEWER', 'ADMIN']}>
              <Reviewer />
            </Protected>
          }
        />
        <Route
          path="/reviewer/submissions/:id"
          element={
            <Protected roles={['REVIEWER', 'ADMIN']}>
              <ReviewDetail />
            </Protected>
          }
        />
        <Route
          path="/admin"
          element={
            <Protected roles={['ADMIN']}>
              <Admin />
            </Protected>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
